// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var Local_storage_utils = require("../ui-utils/Local_storage_utils.bs.js");
var Button = require("@mui/material/Button").default;
var Checkbox = require("@mui/material/Checkbox").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

var showProofTableLocStorKey = "export-proof-show-proof-table";

var essentialsOnlyLocStorKey = "export-proof-essentials-only";

function MM_cmp_export_proof(Props) {
  var proofText = Props.proofText;
  var proofTableWithTypes = Props.proofTableWithTypes;
  var proofTableWithoutTypes = Props.proofTableWithoutTypes;
  var onClose = Props.onClose;
  var match = React.useState(function () {
        return Belt_Option.getWithDefault(Local_storage_utils.locStorReadBool(showProofTableLocStorKey), false);
      });
  var setShowProofTablePriv = match[1];
  var showProofTable = match[0];
  var setShowProofTable = function (showProofTable) {
    Local_storage_utils.locStorWriteBool(showProofTableLocStorKey, showProofTable);
    Curry._1(setShowProofTablePriv, (function (param) {
            return showProofTable;
          }));
  };
  var match$1 = React.useState(function () {
        return Belt_Option.getWithDefault(Local_storage_utils.locStorReadBool(essentialsOnlyLocStorKey), false);
      });
  var setEssentialsOnlyPriv = match$1[1];
  var essentialsOnly = match$1[0];
  var setEssentialsOnly = function (essentialsOnly) {
    Local_storage_utils.locStorWriteBool(essentialsOnlyLocStorKey, essentialsOnly);
    Curry._1(setEssentialsOnlyPriv, (function (param) {
            return essentialsOnly;
          }));
  };
  var getTextToCopy = function (param) {
    return proofText + (
            showProofTable ? (
                essentialsOnly ? "\n\n" + proofTableWithoutTypes : "\n\n" + proofTableWithTypes
              ) : ""
          );
  };
  var rndProofTable = function (param) {
    if (showProofTable) {
      if (essentialsOnly) {
        return React.createElement("pre", undefined, proofTableWithoutTypes);
      } else {
        return React.createElement("pre", undefined, proofTableWithTypes);
      }
    } else {
      return null;
    }
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: React.createElement(Expln_React_Column.make, {
                    spacing: 1,
                    children: null
                  }, React.createElement(Expln_React_Row.make, {
                        children: null
                      }, React.createElement(FormControlLabel, {
                            control: React.createElement(Checkbox, {
                                  checked: showProofTable,
                                  onChange: (function (param) {
                                      return Expln_React_common.evt2bool(setShowProofTable, param);
                                    })
                                }),
                            label: "proof table"
                          }), React.createElement(FormControlLabel, {
                            control: React.createElement(Checkbox, {
                                  checked: essentialsOnly,
                                  onChange: (function (param) {
                                      return Expln_React_common.evt2bool(setEssentialsOnly, param);
                                    })
                                }),
                            label: "essentials only",
                            disabled: !showProofTable
                          }), React.createElement(Button, {
                            onClick: (function (param) {
                                MM_react_common.copyToClipboard(getTextToCopy(undefined));
                              }),
                            variant: "contained",
                            children: "Copy"
                          }), React.createElement(Button, {
                            onClick: (function (param) {
                                Curry._1(onClose, undefined);
                              }),
                            children: "Close"
                          })), React.createElement("pre", {
                        style: {
                          whiteSpace: "pre-wrap",
                          overflowWrap: "break-word"
                        }
                      }, proofText), rndProofTable(undefined))
            });
}

var make = MM_cmp_export_proof;

exports.showProofTableLocStorKey = showProofTableLocStorKey;
exports.essentialsOnlyLocStorKey = essentialsOnlyLocStorKey;
exports.make = make;
/* react Not a pure module */
